import { Tooltip, UIText3, TPlacement } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './PriceDisclaimer.css';
import { PRICE_DISCLAIMER_TEXT_MAP, TVillageOffersType } from '../../constants/base';
import { InfoIcon } from '../common/icons';

export interface IPriceDisclaimerProps {
  size: string;
  type: TVillageOffersType | undefined;
  position?: TPlacement;
  mediaType?: 'desktop' | 'mobile';
}

export const PriceDisclaimer: React.FC<IPriceDisclaimerProps> = ({ size, type, position, mediaType = 'desktop' }) => {
  // Не рендерим дисклеймер без типа или в кейсе: только первичка без фичафлага
  if (!type) {
    return null;
  }
  const isMobile = mediaType === 'mobile';

  return (
    <div {...mergeStyles(styles['container'], isMobile && styles['container-mobile'])}>
      <Tooltip theme="white" placement={position} title={<UIText3>{PRICE_DISCLAIMER_TEXT_MAP[type]}</UIText3>}>
        <div {...mergeStyles(isMobile && styles['icon-mobile'])}>
          <InfoIcon size={size} />
        </div>
      </Tooltip>
    </div>
  );
};
